<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 09:39:27
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-07 15:26:41
 * @name: 待处理
 * @Description: 待处理
 * @FilePath: \project\src\views\index\afterSaleWaitDeal\afterSaleWaitDealRouter.vue
 * @Author: desktop
-->
<template>
  <div class="afterSaleWaitDealRouter">
    <keep-alive :include="cashRouters">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "indexAfterSaleWaitDeal",
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    },
  },
};
</script>
<style lang="scss" scoped>
.afterSaleWaitDealRouter {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>